export const RECEIVE_USERS = 'RECEIVE_USERS'


// WEBPACK FOOTER //
// ./src/constants/actions-types.js